/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Templates,
    TemplatesFromJSON,
    TemplatesFromJSONTyped,
    TemplatesToJSON,
} from './Templates';

/**
 * GET /templates
 * @export
 * @interface GetTemplatesSuccessResponse
 */
export interface GetTemplatesSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTemplatesSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetTemplatesSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Templates>}
     * @memberof GetTemplatesSuccessResponse
     */
    data: Array<Templates>;
}

export function GetTemplatesSuccessResponseFromJSON(json: any): GetTemplatesSuccessResponse {
    return GetTemplatesSuccessResponseFromJSONTyped(json, false);
}

export function GetTemplatesSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemplatesSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(TemplatesFromJSON)),
    };
}

export function GetTemplatesSuccessResponseToJSON(value?: GetTemplatesSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(TemplatesToJSON)),
    };
}

